export default __webpack_public_path__ + "static/media/hawk.3bcdb3f1.png";